import PropTypes from 'prop-types';

export const ComponentType = PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
]);

export const IDType = PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
]);



// WEBPACK FOOTER //
// ./scripts/utils/prop-types.js